import React, { FunctionComponent } from "react";
import classnames from "classnames";

import { KeyboardKeyInfo } from "../models/KeyboardKeyInfo";

import "./KeyboardKey.scss";

interface KeyboardKeyProps {
    data: KeyboardKeyInfo;
    isShift: boolean;
    onShiftClick: () => void;
}

export const KeyboardKey: FunctionComponent<KeyboardKeyProps> = ({
    data,
    isShift,
    onShiftClick,
}) => {
    function handleClick(): void {
        if (data.type === "shift") {
            onShiftClick();
        } else {
            data.onClick(isShift);
        }
    }

    return (
        <span
            className={classnames("keyboard_key", {
                "shift-key": data.type === "shift",
                "backspace-key": data.type === "backspace",
                "space-key": data.type === "space",
            })}
            onClick={handleClick}
            data-testid="keyboard-key"
        >
            {isShift ? data.shiftDisplay : data.display}
        </span>
    );
};
